import { ScreeningInsightsResponse } from '@estercare/ester-shared'
import { SummaryMetrics } from './types'

type SummaryMetric = SummaryMetrics[keyof SummaryMetrics]

const MIN_HIGHLIGHT_PCT = 10

export const getSummaryMetrics = (insights?: ScreeningInsightsResponse): SummaryMetrics => ({
  improvedWorkAbility: insights?.improvedWorkAbility,
  lifestyleChange: insights?.lifestyleChange,
  decreasedSymptoms3m: insights?.decreasedSymptoms3m,
})

export const meetsHighlightThreshold = (pct: number) => Math.round(pct) >= MIN_HIGHLIGHT_PCT

/** A missing metric stays visible so its tile can show the not-enough-data state. */
export const isSummaryTileVisible = (metric: SummaryMetric) => !metric || meetsHighlightThreshold(metric.pct)

export const getHighlightPcts = ({ decreasedSymptoms3m, lifestyleChange, improvedWorkAbility }: SummaryMetrics) => {
  if (!decreasedSymptoms3m || !lifestyleChange || !improvedWorkAbility) return null

  const pcts = {
    decreasedSymptomsPct: Math.round(decreasedSymptoms3m.pct),
    lifestylePct: Math.round(lifestyleChange.pct),
    workAbilityPct: Math.round(improvedWorkAbility.pct),
  }
  const allAboveThreshold = Object.values(pcts).every(meetsHighlightThreshold)

  return allAboveThreshold ? pcts : null
}
